import Contact from '@/components/pages/contact/contact';
import EditContact from '@/components/pages/contact/edit_contact';
import Position from '@/components/pages/contact/position';

export default [
    {
        name: 'contact',
        path: '/contact',
        component: Contact
    },
    {
        name: 'edit_contact',
        path: '/edit_contact',
        component: EditContact
    },
    {
        name: 'position',
        path: '/contact/position',
        component: Position
    }
];



// WEBPACK FOOTER //
// ./src/router/contact/contact.js